module.exports = __webpack_public_path__ + "ad5c5ec38e159be8b25362fe0b543c8f.png";